const data = {
  diet: [
    { label: "Balanced", value: "balanced" },
    { label: "High-Fiber", value: "high-fiber" },
    { label: "High-Protein", value: "high-protein" },
    { label: "Low-Carb", value: "low-carb" },
    { label: "Low-Fat", value: "low-fat" },
    { label: "Low-Sodium", value: "low-sodium" },
  ],
  health: [
    { label: "Kosher", value: "kosher" },
    { label: "Peanut-Free", value: "peanut-free" },
    { label: "Red-Meat-Free", value: "red-meat-free" },
    { label: "Soy-Free", value: "soy-free" },
    { label: "Dairy-Free", value: "dairy-free" },
    { label: "Vegan", value: "vegan" },
  ],
  cuisine: [
    { label: "Asian" },
    { label: "Caribbean" },
    { label: "American" }
  ]
}

export default data;